import { addUnauthenticatedReset } from "domains/authentication/utils";
import type { FetchPermissionAction } from "entities/permissions/actionTypes";
import { PermissionsType } from "entities/permissions/actionTypes";
import { TM_LICENSE_PERSONAL } from "entities/permissions/constants";
import type { PermissionData } from "entities/permissions/types";

export const initialState: PermissionData = {
  bookmarks: { access: false, display: false },
  collections: { can_edit_collections: false, can_feature: false, can_list: false },
  communities: { can_edit_communities: false },
  create: {
    access: false,
    display: false,
    features: {
      custom_content: false,
      custom_key_issues: false,
      generative_maps: false,
      map_limit: 0,
      map_restriction: true,
      map_set_sharing: false,
    },
  },
  discover: {
    access: true,
    display: true,
    features: {
      advanced_mode: false,
      briefing: false,
      custom_content: false,
      data: true,
      dialogue: false,
      events: false,
      forum_events: false,
      forum_experts: false,
      forum_initiatives: false,
      image_export: false,
      initiatives: false,
      presentation_export: false,
      publications: true,
      stakeholders: false,
      tab_content_visible: false,
      tm_license: TM_LICENSE_PERSONAL,
      videos: true,
    },
  },
  global: {
    features: {
      app_banner: false,
      become_member: false,
      become_pro_member: false,
      follow_topics: false,
      notifications: false,
      signals: false,
    },
  },
  knowledge: { can_add_knowledge: false, can_reject_knowledge: false },
  membership_events: { access: false, display: false },
  monitor: { access: false, display: true },
  profile: { access: false, display: false },
  sources: {
    can_edit_sources: false,
    can_view_sources: false,
  },
};

const reducer = (state = initialState, action: FetchPermissionAction) => {
  switch (action.type) {
    case PermissionsType.FETCH_FULFILLED:
      return action.payload;
    default:
      return state;
  }
};

export const permissionsReducer = addUnauthenticatedReset(reducer, initialState);
